module.exports = __webpack_public_path__ + "static/media/Talc.e4ca2e5e.jpg";